import React from 'react';
import {Alert, Form, Icon, Input, Button, Row, Col, Select, Radio} from 'antd';
import get from 'lodash/get';

import {
  createCoenrollmentProfileRequest,
  updateCoenrollmentProfileRequest,
} from '../../api/requests';

import classes from './PatientProfileForm.css';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class PatientCoenrollmentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: '',
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({ isLoading: true, errorMessage: null, responseMessage: null });

        try {
          const data = {...values};

          if (this.props.profile) {
            await updateCoenrollmentProfileRequest(this.props.subjectID, data);
          } else {
            await createCoenrollmentProfileRequest(this.props.subjectID, data);
          }

          this.setState({ responseMessage: 'Success' });

          setTimeout(() => {
            this.props.onSubmit(this.props.subjectID);
          }, 1500);
        } catch (err) {
          this.setState({ errorMessage: get(err, 'response.data.msg', get(err, 'response.data.errors._schema[0]')), isLoading: false});
        }
      }
    });
  };


  render() {
    const { getFieldDecorator, getFieldsError, getFieldValue } = this.props.form;
    const { isLoading, errorMessage, responseMessage, checkConfirmRequestError } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={8}>
            <Col sm={6}>
                <Form.Item label='Was patient enrolled in any other trial?'>
                  {getFieldDecorator('is_enrolled_other_trial', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'profile.is_enrolled_other_trial', '')
                  })(
                    <Radio.Group>
                      <Radio value={true}>Yes</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>,
                  )}
                </Form.Item>
            </Col>
          </Row>
          {getFieldValue("is_enrolled_other_trial") && <Row gutter={8}>
            <Col sm={6}>
              <Form.Item label='Please select the co-enrollment trial name'>
                {getFieldDecorator('enrolled_trial_name', {
                  rules: [{ required: true, message: 'Required' }],
                  initialValue: get(this.props, 'profile.enrolled_trial_name', '')
                })(
                  <Select>
                    <Select.Option value='easi_toc'>EASI TOC</Select.Option>
                    <Select.Option value='other'>Other</Select.Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>}
          {getFieldValue("enrolled_trial_name") === 'other' && <Row gutter={8}>
            <Col sm={6}>
              <Form.Item label='Other trial name'>
                {getFieldDecorator('other_enrolled_trial_name', {
                  rules: [{ required: true, message: 'Required' }],
                  initialValue: get(this.props, 'profile.other_enrolled_trial_name', '')
                })(
                  <Input.TextArea />,
                )}
              </Form.Item>
            </Col>
          </Row>}

          {errorMessage && <Alert message={errorMessage} type="error" className={classes.alertsMb} />}
          {responseMessage && <Alert message={responseMessage} type="success" className={classes.alertsMb} />}
          {checkConfirmRequestError && <Alert message={checkConfirmRequestError} type="error" className={classes.alertsMb} />}

          {!responseMessage && !checkConfirmRequestError && (<Row gutter={12}>
            <Col span={12}>
              <Form.Item>
                <Button type="primary" size="large" htmlType="submit" disabled={hasErrors(getFieldsError())} className={classes.submitButton}>
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            </Col>
          </Row>)}

        </Form>
      </div>
    );
  }
}

export default Form.create({ name: 'patientCoenrollmentForm' })(PatientCoenrollmentForm);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientCoenrollmentForm.js